import api from './api';

// Returns every toolbox session.
async function getAll() {
  return api.get('/sesiones_toolbox');
}

// Returns one toolbox session by id.
async function getById(id) {
  return api.get(`/sesiones_toolbox/${id}`);
}

// Returns toolbox sessions filtered by responsable.
async function getByResponsable(responsableId) {
  return api.get(
    `/sesiones_toolbox?responsableId=${encodeURIComponent(responsableId)}`
  );
}

// Creates a new toolbox session.
async function create(data) {
  return api.post('/sesiones_toolbox', {
    ...data,
    tipo: 'toolbox',
  });
}

// Updates an existing toolbox session.
async function update(id, data) {
  return api.put(`/sesiones_toolbox/${id}`, data);
}

// Removes a toolbox session.
async function remove(id) {
  return api.delete(`/sesiones_toolbox/${id}`);
}

const sesionToolboxService = {
  getAll,
  getById,
  getByResponsable,
  create,
  update,
  remove,
};

export default sesionToolboxService;
